var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 7.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.22,7.3v-1.04H1.4V1.36l-1.4,.19V.71L1.84,.12h.86V6.26h1.18v1.04H.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.14,7.3v-.66c0-.82,.57-1.45,1.23-1.98,1.04-.85,2.32-1.38,2.32-2.5,0-.71-.41-1.09-1.08-1.09s-1.09,.36-1.27,1.23l-1.12-.24c.2-1.32,1.11-2.06,2.49-2.06,1.47,0,2.26,.8,2.26,2.08,0,1.69-1.83,2.49-2.74,3.26-.35,.29-.59,.6-.6,.88h3.37v1.08H5.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.fefb640802844f8501f330e96c63dc55.svg";
export { ForwardRef as ReactComponent };